<template>
  <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="15" :lg="12" :xl="10" id="center">
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="18">
            <div>
              <h2 style="text-align:center">重置密码</h2>
              <el-form :model="forgetForm" status-icon :rules="rules" ref="forgetForm" label-width="50px"
                class="demo-ruleForm" style="margin-top: 0">
                <el-form-item prop="name">
                  <el-input type="text" placeholder="电话" v-model="forgetForm.name" auto-complete="off" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input type="password" placeholder="新密码" v-model="forgetForm.pass" auto-complete="off" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item prop="repass">
                  <el-input type="password" placeholder="确认新密码" v-model="forgetForm.repass" auto-complete="off"
                    clearable></el-input>
                </el-form-item>
                <el-form-item prop="mobile">
                  <el-input type="text" placeholder="手机验证码" v-model="forgetForm.mobile" auto-complete="off"
                    style="width:45%" clearable></el-input>
                  <el-button plain style="margin-left:3%;width:50%" @click="getCode(this)" :disabled="isDisabled">
                    {{ buttonName }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button @click="login()" style="width:48%">取消</el-button>
                  <el-button @click="submitForm('forgetForm')" style="width:48%">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { forget, phoneCode } from '@/api/Login';

export default {
  data() {
    // var tel=/^1[345678]\d{9}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('请输入用户名');
      } else {
        if (this.forgetForm.name !== '') {
        }
        callback();
      }
      // } else if(tel.test(value)){
      //    callback();
      // } else {
      //   if (this.forgetForm.pass !== '') {
      //     this.$refs.forgetForm.validateField('pass');
      //   }
      //   callback(new Error('请输入正确的手机号'));
      // }
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback('请输入密码');
      } else {
        if (this.forgetForm.pass !== '') {
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.forgetForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback('请输入手机验证码');
      } else {
        if (this.forgetForm.mobile !== '') {
        }
        callback();
      }
    };
    const validateCheck = (rule, value, callback) => {
      if (value === '') {
        callback('请输入验证码');
      } else {
        if (this.forgetForm.check !== '') {
        }
        callback();
      }
    };
    return {
      buttonName: '获取手机验证码',
      isDisabled: false,
      time: 120,
      forgetForm: {
        name: '',
        pass: '',
        repass: '',
        mobile: '',
        check: '',
      },
      rules: {
        name: [
          { validator: validateName, trigger: 'blur' },
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        repass: [
          { validator: validatePass2, trigger: 'blur' },
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' },
        ],
        check: [
          { validator: validateCheck, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 返回登录
    login() {
      this.$router.push({ path: '/' });
    },
    // 获取手机验证码
    getCode(obj) {
      const me = this;
      me.isDisabled = true;
      const interval = window.setInterval(() => {
        me.buttonName = `（${me.time}秒）后重新发送`;
        --me.time;
        if (me.time < 0) {
          me.buttonName = '重新发送';
          me.time = 10;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
      const data = { // http请求的参数
        MOBILE: this.forgetForm.name,
      };
      phoneCode(data).then((res) => {
        console.log('成功');
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 重置密码
    submitForm(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = { // http请求的参数
                MOBILE: this.forgetForm.name,
                NEW_PASSWORD: this.forgetForm.pass,
                VALIDATE_CODE: this.forgetForm.mobile,
              };
              forget(data).then((res) => {
                this.$message.show({
                  text: '重置成功',
                  type: 'success',
                });
                this.$router.push({ path: '/' });
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: '重置失败',
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>
<style>
#center {
  margin-top: 10%;
  padding-top: 50px;
  padding-bottom: 50px;
  background: url('../assets/images/center.png') no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.container {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
  padding: 0;
  background: url('../assets/images/background1.jpg') no-repeat;
  /* background: url('../assets/images/background.png') no-repeat center center !important; */
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.el-form {
  margin-right: 50px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>




// WEBPACK FOOTER //
// src/components/forget.vue